import type { AxiosRequestConfig } from 'axios'

import { shipmentApiClient } from '../shipmentApiClient'
import { upsertDeliveryWorkEndpoint } from './endpoint'
import type { UpsertDeliveryWorkParams, UpsertDeliveryWorkResponse } from './type'

export const upsertDeliveryWork = async (
  params: UpsertDeliveryWorkParams
): Promise<UpsertDeliveryWorkResponse> => {
  const formData = new FormData()
  // BE は @ModelAttribute で Kotlin プロパティ名（camelCase）に直接バインドするため、
  // part 名は camelCase のまま送る。
  formData.append('deliveryReportUid', params.deliveryReportUid)
  formData.append('driverPhone', params.driverPhone)
  // items はインデックス付きフォームバインド形式（items[0].deliveryWorkTypeTenantSettingId）で送る。
  // 0 件（荷役なし）のときは part 自体を送らない = BE で items 空扱い
  params.itemSettingIds.forEach((id, index) => {
    formData.append(`items[${index}].deliveryWorkTypeTenantSettingId`, String(id))
  })
  // note が null（空メモ）のときは part を送らず BE 側で note=null 扱いにする
  if (params.note !== null) {
    formData.append('note', params.note)
  }
  // 残す既存添付・新規添付はそれぞれ同名複数 part 形式で繰り返し append する
  params.keptAttachmentIds.forEach((id) => {
    formData.append('keptAttachmentIds', String(id))
  })
  params.newAttachments.forEach((file) => {
    formData.append('newAttachments', file)
  })

  const { data } = await shipmentApiClient.put<UpsertDeliveryWorkResponse>(
    upsertDeliveryWorkEndpoint(params.shipmentUid, params.visitId),
    formData,
    // - skipDataDecamelize: interceptor が FormData を decamelizeKeys で破壊するのを防ぐ
    //   （part 名は既に camelCase で確定済みのため変換不要）
    // - Content-Type を multipart にすることで axios v1 が FormData を JSON 化するのを防ぐ。
    //   ブラウザの xhr adapter が boundary 付きの値に置き換えるため値自体は任意。
    {
      skipDataDecamelize: true,
      headers: { 'Content-Type': 'multipart/form-data' },
    } as unknown as AxiosRequestConfig
  )
  return data
}
